import { render, staticRenderFns } from "./BlockSend.vue?vue&type=template&id=da6f5eea"
import script from "./BlockSend.vue?vue&type=script&lang=js"
export * from "./BlockSend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports